import { ReactNode } from 'react';
import { SkeletonText, Stack, Typography } from '@optimus-web/core';

export const ValueItem = ({
    title,
    value,
    isLoading,
}: {
    title: ReactNode;
    value: ReactNode | undefined;
    isLoading: boolean;
}) => (
    <Stack distribution="space-between" itemAlignment="center">
        <Typography textStyle="bodyMedium" variant="tertiary" as="div">
            {title}
        </Typography>
        <Typography textStyle="bodyMedium" as="div">
            {isLoading ? <SkeletonText fontSize={14} /> : value}
        </Typography>
    </Stack>
);
